export default __webpack_public_path__ + "static/media/dog_200_200.871cb004.jpg";